import React, { useEffect, useMemo, useState } from 'react';
import GenericModal from '../../../components/agv-generic-modal';
import ConsignmentRuleFormFields, {
  buildConsignmentRulePayload,
  isConsignmentRuleFormValid,
} from './consignment-rule-form-fields';
import {
  CONSIGNMENT_RULE_TYPES,
  CONSIGNMENT_DEFAULT_WEIGHT_UNIT,
} from '../../../utils/consignment-rule.util';

export default function ConsignmentRuleCreateModal({
  isOpen,
  setIsOpen,
  createConsignmentRule,
  mainActionIsLoading,
  packagingOptions,
}) {
  const [itemKey, setItemKey] = useState('');
  const [packagingId, setPackagingId] = useState(null);
  const [ruleType, setRuleType] = useState(CONSIGNMENT_RULE_TYPES.LINE_DIRECT);
  const [productsPerPallet, setProductsPerPallet] = useState('');
  const [weightDivisor, setWeightDivisor] = useState('');
  const [weightUnit, setWeightUnit] = useState(CONSIGNMENT_DEFAULT_WEIGHT_UNIT);
  const [isActive, setIsActive] = useState('true');

  const isValid = useMemo(
    () =>
      isConsignmentRuleFormValid({
        itemKey,
        packagingId,
        ruleType,
        productsPerPallet,
        weightDivisor,
        weightUnit,
      }),
    [
      itemKey,
      packagingId,
      ruleType,
      productsPerPallet,
      weightDivisor,
      weightUnit,
    ]
  );

  useEffect(() => {
    if (!isOpen) {
      setItemKey('');
      setPackagingId(null);
      setRuleType(CONSIGNMENT_RULE_TYPES.LINE_DIRECT);
      setProductsPerPallet('');
      setWeightDivisor('');
      setWeightUnit(CONSIGNMENT_DEFAULT_WEIGHT_UNIT);
      setIsActive('true');
    }
  }, [isOpen]);

  const handleSubmit = () => {
    createConsignmentRule(
      buildConsignmentRulePayload({
        itemKey,
        packagingId,
        ruleType,
        productsPerPallet,
        weightDivisor,
        weightUnit,
        isActive,
      })
    );
  };

  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={'Créer une règle de consigne'}
      mainAction={handleSubmit}
      mainActionText={'Créer'}
      mainActionIsLoading={mainActionIsLoading}
      mainActionDisabled={!isValid}
    >
      <ConsignmentRuleFormFields
        itemKey={itemKey}
        setItemKey={setItemKey}
        packagingId={packagingId}
        setPackagingId={setPackagingId}
        ruleType={ruleType}
        setRuleType={setRuleType}
        productsPerPallet={productsPerPallet}
        setProductsPerPallet={setProductsPerPallet}
        weightDivisor={weightDivisor}
        setWeightDivisor={setWeightDivisor}
        weightUnit={weightUnit}
        setWeightUnit={setWeightUnit}
        isActive={isActive}
        setIsActive={setIsActive}
        packagingOptions={packagingOptions}
      />
    </GenericModal>
  );
}
